import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	addEmoRequestDTO,
	EmoPageFilter,
	InformationEmotionSupportDTO,
	SortEmoListDTO,
} from '../DTO/information/emo.interface';

export const emoApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getEmoList: builder.query<
			SuccessResponse<Paginated<InformationEmotionSupportDTO>>,
			EmoPageFilter
		>({
			query: (body) => ({
				url: `/web/information/emotion-support/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['EmoList'],
		}),

		sortEmoList: builder.mutation<
			SuccessResponse<any>,
			{ sortList: SortEmoListDTO[] }
		>({
			query: (body) => ({
				url: `/web/information/emotion-support/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['EmoList'],
		}),
		deleteEmo: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/information/emotion-support/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['EmoList'],
		}),
		createEmo: builder.mutation<SuccessResponse<any>, addEmoRequestDTO>({
			query: (body) => ({
				url: `/web/information/emotion-support`,
				method: 'POST',
				body,
			}),
		}),
		getEmoDetail: builder.query<
			SuccessResponse<InformationEmotionSupportDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/information/emotion-support/${id}`,
				method: 'GET',
			}),
			providesTags: ['EmoDetail'],
		}),
		updateEmo: builder.mutation<
			SuccessResponse<any>,
			InformationEmotionSupportDTO
		>({
			query: (body) => ({
				url: `/web/information/emotion-support`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['EmoDetail'],
		}),
	}),
});

export const {
	useGetEmoListQuery,
	useGetEmoDetailQuery,
	useSortEmoListMutation,
	useDeleteEmoMutation,
	useCreateEmoMutation,
	useUpdateEmoMutation,
} = emoApiSlice;
